import { CLAIMS } from '@libs/authentication/claims';

import { CategoryId, NavMenuItem } from './nav-menu-interface';

export enum MenuIds {
  Dashboard = 'dashboard',
  Posting = 'posting',
  Promote = 'promote',
  Career = 'career',
  Interview = 'interview',
  InterviewScheduled = 'interview-scheduled',
  InterviewAvailability = 'interview-availability',
  Candidate = 'candidate',
  FeaturedAd = 'featured-ad',
  PostingPerformance = 'posting-performance',
  CampaignPerformance = 'campaign-performance',
  Billing = 'billing',
  Users = 'users',
  Feeds = 'feeds',
  Audit = 'audit',
  Roles = 'roles',
  CompanyInfo = 'company-info',
}

export const NAV_MENU: NavMenuItem[] = [
  {
    id: MenuIds.Dashboard,
    route: '/recruiting/dashboard',
    label: 'Dashboard',
    enabled: true,
    denyClaims: [CLAIMS.locationManager],
    categoryId: CategoryId.Main,
  },
  {
    id: MenuIds.Posting,
    route: '/recruiting/postings',
    label: 'Postings',
    claims: [CLAIMS.canManagePostings, CLAIMS.canViewPostings],
    enabled: false,
    categoryId: CategoryId.Main,
  },
  {
    id: MenuIds.Promote,
    route: '/recruiting/promote',
    label: 'Campaigns',
    claims: [CLAIMS.canManageCampaigns, CLAIMS.canViewCampaigns],
    enabled: false,
    categoryId: CategoryId.Main,
  },
  {
    id: MenuIds.FeaturedAd,
    route: '/recruiting/featured-employer/overview',
    label: 'Featured employer',
    claims: [CLAIMS.canManageCampaigns],
    enabled: false,
    categoryId: CategoryId.Main,
  },
  {
    id: MenuIds.Candidate,
    route: '/recruiting/candidates',
    label: 'Candidates',
    enabled: false,
    claims: [CLAIMS.canManageApplicants, CLAIMS.canViewApplicants],
    categoryId: CategoryId.Main,
  },
  {
    id: MenuIds.InterviewScheduled,
    route: '/business/interview-availability/scheduled',
    label: 'Interviews',
    enabled: false,
    claims: [CLAIMS.canManageApplicants, CLAIMS.canManageCandidateSearch],
    categoryId: CategoryId.Main,
  },
  {
    id: MenuIds.CampaignPerformance,
    route: '/recruiting/reports/campaign-performance',
    label: 'Campaign performance',
    enabled: false,
    claims: [CLAIMS.canManageCampaigns],
    categoryId: CategoryId.Reports,
  },
  {
    id: MenuIds.PostingPerformance,
    route: '/recruiting/reports/posting-performance',
    label: 'Posting performance',
    enabled: false,
    claims: [CLAIMS.canManageCampaigns],
    categoryId: CategoryId.Reports,
  },
  {
    id: MenuIds.InterviewAvailability,
    route: '/business/interview-availability',
    label: 'Interview availability',
    enabled: false,
    claims: [CLAIMS.canManageApplicants, CLAIMS.canManageCandidateSearch],
    categoryId: CategoryId.Organization,
  },
  {
    route: '/business/locations',
    label: 'Location',
    claims: [CLAIMS.canManageLocations, CLAIMS.canViewLocations],
    enabled: false,
    categoryId: CategoryId.Organization,
  },
  {
    route: '/business/brands',
    label: 'Brands',
    selfSignupLabel: 'Brand',
    claims: [CLAIMS.canManageBrands],
    enabled: false,
    categoryId: CategoryId.Organization,
  },
  {
    route: '/business/positions',
    label: 'Position Templates',
    claims: [CLAIMS.canManagePositions, CLAIMS.canViewPositions],
    enabled: false,
    categoryId: CategoryId.Organization,
  },
  {
    route: '/recruiting/career-sites',
    label: 'Career Sites',
    claims: [CLAIMS.canManageCareerSites],
    enabled: false,
    categoryId: CategoryId.Organization,
  },
];

export const ACCOUNT_SETTINGS_MENU: NavMenuItem[] = [
  {
    id: MenuIds.Billing,
    route: '/business/billing',
    label: 'Billing',
    claims: [CLAIMS.canManageBilling],
    enabled: false,
  },
  {
    id: MenuIds.Users,
    route: '/business/users',
    label: 'Users',
    claims: [CLAIMS.canViewUsers, CLAIMS.canManageUsers],
    enabled: false,
  },
  {
    id: MenuIds.Feeds,
    route: '/recruiting/feed',
    label: 'Feeds',
    claims: [CLAIMS.canViewFeeds],
    enabled: false,
  },
  {
    id: MenuIds.Audit,
    route: '/business/audit',
    label: 'Audit',
    enabled: true,
  },
  {
    id: MenuIds.Roles,
    route: '/business/roles',
    label: 'Roles',
    claims: [CLAIMS.canManageUsers],
    enabled: false,
  },
  {
    id: MenuIds.CompanyInfo,
    route: '/business/information',
    label: 'Company info',
    enabled: true,
  },
];

// Deprecated based on old nav menu
export const MOBILE_MENU: NavMenuItem[] = [
  {
    route: '/recruiting/dashboard',
    label: 'Home',
    enabled: true,
    denyClaims: [CLAIMS.locationManager],
  },
  {
    route: '/recruiting/postings',
    label: 'Postings',
    claims: [CLAIMS.canManagePostings, CLAIMS.canViewPostings],
    enabled: false,
  },
  {
    route: '/recruiting/promote',
    label: 'Promote',
    claims: [CLAIMS.canManageCampaigns, CLAIMS.canViewCampaigns],
    enabled: false,
  },
  {
    route: 'recruiting/reports',
    label: 'Reports',
    enabled: true,
    isDropdownTrigger: true,
    categoryId: CategoryId.Reports,
  },
  {
    route: '/recruiting/reports/campaign-performance',
    label: 'Campaign performance',
    enabled: false,
    claims: [CLAIMS.canManageCampaigns],
    categoryId: CategoryId.Reports,
  },
  {
    route: '/recruiting/reports/posting-performance',
    label: 'Posting performance',
    enabled: false,
    claims: [CLAIMS.canManageCampaigns],
    categoryId: CategoryId.Reports,
  },
  {
    id: MenuIds.Candidate,
    route: '/recruiting/candidates',
    label: 'Candidates',
    enabled: false,
    claims: [CLAIMS.canManageApplicants, CLAIMS.canViewApplicants],
  },
  {
    id: MenuIds.Interview,
    route: '',
    label: 'Interviews',
    enabled: true,
    isDropdownTrigger: true,
    categoryId: CategoryId.Interviews,
  },
  {
    id: MenuIds.InterviewScheduled,
    route: '/business/interview-availability/scheduled',
    label: 'Interviews scheduled',
    enabled: false,
    claims: [CLAIMS.canManageApplicants, CLAIMS.canManageCandidateSearch],
    categoryId: CategoryId.Interviews,
  },
  {
    id: MenuIds.InterviewAvailability,
    route: '/business/interview-availability',
    label: 'Interview availability',
    enabled: false,
    claims: [CLAIMS.canManageApplicants, CLAIMS.canManageCandidateSearch],
    categoryId: CategoryId.Interviews,
  },
  {
    id: MenuIds.FeaturedAd,
    route: '/recruiting/featured-employer',
    label: 'Featured employer',
    claims: [CLAIMS.canManageCampaigns],
    enabled: false,
  },
  {
    route: '/recruiting/career-sites',
    label: 'Career Sites',
    claims: [CLAIMS.canManageCareerSites],
    enabled: false,
  },
];

// Deprecated still used in mobile
export const SETTINGS_MENU: NavMenuItem[] = [
  {
    route: '/business/information',
    label: 'Company Information',
    enabled: true,
  },
  {
    route: '/business/users',
    label: 'Users',
    claims: [CLAIMS.canViewUsers, CLAIMS.canManageUsers],
    enabled: false,
  },
  {
    route: '/business/roles',
    label: 'User roles',
    claims: [CLAIMS.canManageUsers],
    enabled: false,
  },
  {
    route: '/recruiting/feed',
    label: 'Feeds',
    claims: [CLAIMS.canViewFeeds],
    enabled: false,
  },
  {
    route: '/business/billing',
    label: 'Billing',
    claims: [CLAIMS.canManageBilling],
    enabled: false,
  },
  {
    route: '/business/brands',
    label: 'Brands',
    selfSignupLabel: 'Brand',
    claims: [CLAIMS.canManageBrands],
    enabled: false,
  },
  {
    route: '/business/locations',
    label: 'Locations',
    claims: [CLAIMS.canManageLocations, CLAIMS.canViewLocations],
    enabled: false,
  },
  {
    route: '/business/positions',
    label: 'Positions',
    claims: [CLAIMS.canManagePositions, CLAIMS.canViewPositions],
    enabled: false,
  },
  {
    route: '/business/audit',
    label: 'Audit',
    enabled: true,
  },
];
